import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [성능/운영 > 슬라이딩 팝업 > 분석 그래프 설정] 자원 선택 목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getRscListForPerfChartType(params) {
    return axios.post(`${baseUrl}/performance/get-rsc-list-for-perf-chart-type.do`, params);
  },
  /**
   * [성능/운영 > 슬라이딩 팝업 > 분석 그래프 설정] 계정에 따라 설정된 분석 그래프 타입 리스트 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getPerfChartTypeByMgr(params) {
    return axios.post(`${baseUrl}/performance/get-perf-chart-type-list-by-mgr.do`, params);
  },
  /**
   * [성능/운영 > 슬라이딩 팝업 > 분석 그래프 설정] 계정에 따른 분석 그래프 리스트 설정 수정
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updatePerfChartTypeMgrList(params) {
    return axios.post(`${baseUrl}/performance/update-perf-chart-type-mgr-list.do`, params);
  },
  /**
   * [executeDatabaseUserQuery 슬라이딩 팝업 > 연결장비 리스트 > 선택된 장비의 서비스 목록
   * @author najongdang
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getServiceListByElementId(params) {
    return axios.post(`${baseUrl}/performance/get-service-list-by-element-id.do`, params);
  },

  /**
   * [executeDatabaseUserQuery 슬라이딩 팝업 > 연결장비 리스트 > 선택된 서비스에 포함된 장비 목록
   * @author najongdang
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getDeviceListByServiceId(params) {
    return axios.post(`${baseUrl}/performance/get-device-list-by-service-id.do`, params);
  },
  /**
   * [getPerformanceGroupList 그룹 > 성능운영 테이블 데이터 조회]
   * @author {Yang}
   * @param  {[type]} params [managegroupId, objDefineId]
   */
  getPerformanceGroupList(params) {
    return axios.post(`${baseUrl}/performance/get-performance-group-list.do`, params);
  },
  /**
   * [getPerformanceSensorGroupList 센서그룹 > 성능운영 테이블 데이터 조회]
   * @author {Yang}
   * @param  {[type]} params [managegroupId, objDefineId]
   */
  getPerformanceSensorGroupList(params) {
    return axios.post(`${baseUrl}/performance/get-sensor-performance-group-list.do`, params);
  },
  /**
   * [getPerformanceServiceGroupList 서비스 그룹 > 성능운영 테이블 데이터 조회]
   * @author {Yang}
   * @param  {[type]} params [managegroupId, objDefineId]
   */
  getPerformanceServiceGroupList(params) {
    return axios.post(`${baseUrl}/performance/get-service-performance-group-list.do`, params);
  },
  /**
   * [성능/운영>그룹>공통] 성능조회
   * @author kimjy
   * @param  {Object} params mamagegroupIds, objDefineIds
   */
  getGroupPerformanceInfo(params) {
    return axios.post(`${baseUrl}/performance/get-group-performance-info.do`, params);
  },
  /**
   * [getPerformanceE2EGroupList E2E 그룹 > 성능운영 테이블 데이터 조회]
   * @author {Yang}
   */
  getPerformanceE2EGroupList(params) {
    return axios.post(`${baseUrl}/performance/get-e2e-performance-group-list.do`, params);
  },
  /**
   * [getPerformanceDatabaseGroupList DATABASE 그룹 > 성능운영 테이블 데이터 조회]
   * @author {Yang}
   */
  getPerformanceDatabaseGroupList(params) {
    return axios.post(`${baseUrl}/performance/get-database-performance-group-list.do`, params);
  },
  /**
   * [getGroupHeatmapList 그룹 > heatmap 리스트를 출력한다. ]
   * @author {YANG}
   */
  getGroupHeatmapList(params) {
    return axios.post(`${baseUrl}/performance/get-group-heatmap-list.do`, params);
  },
  /**
   * [성능/운영 > 루트] 관리그룹 및 관리대상 개수 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getGroupObjCount(params) {
    return axios.post(`${baseUrl}/performance/get-group-obj-count.do`, params);
  },
  /**
   * [성능/운영 > 루트] 타임라인 데이터 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getTimelineData(params) {
    return axios.post(`${baseUrl}/performance/get-timeline-data.do`, params);
  },
  /**
   * [성능/운영 > 루트] 전체 관제 대상에 대한 이벤트 발생 건수, 장비 및 서비스 개수 조회
   * @author jeee12
   * @return {[type]}        [description]
   */
  getObjEventInfo(params) {
    return axios.post(`${baseUrl}/performance/get-obj-event-info.do`, params);
  },
  /**
   * [성능/운영] 제어 스크립트를 조회한다.
   * @author Song
   * @return {[type]}        [description]
   */
  getCtrlScriptSet(param) {
    return axios.get(`${baseUrl}/performance/get-ctrl-script-set.do?managetypeId=${param.managetypeId}`);
  },
  /**
   * [성능/운영] 제어 스크립트를 저장한다.
   * @author Song
   * @return {[type]}        [description]
   */
  insertCtrlScriptSet(params) {
    return axios.post(`${baseUrl}/performance/insert-ctrl-script-set.do`, params);
  },
  /**
   * [성능/운영] 제어 스크립트를 수정한다.
   * @author Song
   * @return {[type]}        [description]
   */
  updateCtrlScriptSet(params) {
    return axios.post(`${baseUrl}/performance/update-ctrl-script-set.do`, params);
  },
  /**
   * [성능/운영] 제어 스크립트를 삭제한다.
   * @author Song
   * @return {[type]}        [description]
   */
  deleteCtrlScriptSet(params) {
    return axios.post(`${baseUrl}/performance/delete-ctrl-script-set.do`, params);
  },
  /**
   * [성능/운영] SKCC 추가 성능자원 표현. total을 제외한 나머지 key의 성능값을 조회
   * @author najongdang
   * @return {[type]}        [description]
   */
  getMultipleRscKeyPerfList(params) {
    return axios.post(`${baseUrl}/performance/get-multiple-rsc-key-perf-list.do`, params);
  },
  /**
   * [성능/운영] SKCC - 성능정보인 모듈상태에 대한 치환값(벤더 기준, 구성 OID)도 조회한다.
   * @author Song
   * @return {[type]}        [description]
   */
  getPerfChangeByConfigOid(params) {
    return axios.post(`${baseUrl}/performance/get-perf-chang-by-config-oid.do`, params);
  },
  /**
   * [성능/운영 > 햄버거 > 수집/판단 > 자원 구분키 관리] obj에 해당하는 obj_rsc_key를 조회하고 해당 자원에 대한 최근 수집시각을 조회
   * @author Song
   * @return {[type]}        [description]
   */
  getObjRscKeyList(params) {
    return axios.post(`${baseUrl}/performance/get-obj-rsc-key-list.do`, params);
  },
  /**
   * [성능/운영 > 햄버거 > 수집/판단 > 자원 구분키 관리] obj에 해당하는 obj_rsc_key를 삭제한다.
   * @author Song
   * @return {[type]}        [description]
   */
  deleteObjRscKeyList(params) {
    return axios.post(`${baseUrl}/performance/delete-obj-rsc-key-list.do`, params);
  },
  /**
   * 무선 AP 정보를 통해 클라이언트 목록을 조회한다.
   * @author yelim
   * @return {[type]}        [description]
   */
  getClientInfoByWireless(params) {
    return axios.get(`${baseUrl}/performance/get-client-info-by-wireless.do`, {
      params,
    });
  },
  /**
   * 무선 AP의 접속자 목록을 조회한다.
   * @author yelim
   * @return {[type]}        [description]
   */
  getApClientStateList(params) {
    return axios.post(`${baseUrl}/performance/get-ap-client-state-list.do`, params);
  },
  /**
   * [성능/운영 > 그룹 > 서버 > 성능 정보] 그리드 데이터 엑셀 출력
   * @author NaJY
   * @param  {[type]} params
   * @return
   */
  exportServerGroupPerfInfo(params) {
    return axios.post(`${baseUrl}/performance/excel-export-group-server-perf-info.do`, params);
  },
  /**
   * [성능/운영 > 그룹 > 네트워크장비 > 성능 정보] 그리드 데이터 엑셀 출력
   * @author NaJY
   * @param  {[type]} params
   * @return
   */
  exportNetdeviceGroupPerfInfo(params) {
    return axios.post(`${baseUrl}/performance/excel-export-group-netdevice-perf-info.do`, params);
  },
  /**
   * [성능/운영 > 그룹 > 무선장비 > 성능 정보 > 컨트롤러] 그리드 데이터 엑셀 출력
   * @author NaJY
   * @param  {[type]} params
   * @return
   */
  exportWirelessControllerGroupPerfInfo(params) {
    return axios.post(`${baseUrl}/performance/excel-export-group-wireless-controller-perf-info.do`, params);
  },
  /**
   * [성능/운영 > 그룹 > 무선장비 > 성능 정보 > 무선AP] 그리드 데이터 엑셀 출력
   * @author NaJY
   * @param  {[type]} params
   * @return
   */
  exportWirelessApGroupPerfInfo(params) {
    return axios.post(`${baseUrl}/performance/excel-export-group-wireless-ap-perf-info.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/common.js